import { KeyCombo, KeyAlias } from '@collaborate-health/uikit/hooks/useHotkey'
import { isMacOs } from 'react-device-detect'

const controlLabel: KeyAlias = isMacOs ? 'Control' : 'Ctrl'

export const ToggleMicrophone: KeyCombo = [controlLabel, 'Shift', 'M']
export const ToggleCamera: KeyCombo = [controlLabel, 'Shift', 'V']

